import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Select } from '@bufferapp/ui';
import styled from 'styled-components';

import { usePlan, planType } from '../../../accountContext';
import { actions } from '../../reducer';

type itemType = {
  id: string;
  title: string;
  selected?: boolean;
  filters: { type: string; status?: string; needsApproval?: boolean }[];
};

const menuItems: itemType[] = [
  {
    id: '1',
    title: 'All Posts',
    filters: [],
    selected: true,
  },
  {
    id: '2',
    filters: [{ type: 'draft' }],
    title: 'Drafts',
  },
  {
    id: '3',
    filters: [{ type: 'post', status: 'pending' }],
    title: 'Scheduled',
  },
  {
    id: '4',
    title: 'Sent Posts',
    filters: [{ type: 'post', status: 'sent' }],
  },
];

export function getPlanItems(plan: planType | undefined): itemType[] {
  if (!plan) return [];

  if (plan.id) {
    if (!['team', 'agency'].includes(plan.id) && plan.isOneBufferOrganization) {
      return [];
    }
  }

  return [
    {
      id: '5',
      title: plan.isAdmin ? 'Pending Approval' : 'Awaiting Approval',
      filters: [{ type: 'draft', needsApproval: true }],
    },
  ];
}

const FilterWrapper = styled.div`
  width: 128px;

  > div {
    width: 128px;

    button {
      justify-content: left;

      div:first-child {
        max-width: 76px;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      div:nth-child(2) {
        margin-left: auto;
      }
    }
  }
`;

export const TypeFilter = (): React.ReactElement => {
  const dispatch = useDispatch();
  const plan = usePlan();
  const [items, setItems] = useState([...menuItems]);

  useEffect(() => {
    setItems([...menuItems, ...getPlanItems(plan)]);
  }, [plan]);

  function handleSelect(selected: itemType): void {
    setItems(
      items.map((item) => ({
        ...item,
        selected: item.id === selected.id,
      }))
    );
    dispatch(actions.updateFilters({ filters: selected.filters }));
  }

  return (
    <FilterWrapper>
      <Select
        onSelectClick={handleSelect}
        label={items.find((i) => i?.selected)?.title}
        items={items}
        hideSearch
        fullWidth
      />
    </FilterWrapper>
  );
};
